import React from 'react';
import styled from 'styled-components';
import logo from '../../assets/logo01-stack.png';
import oceans from '../../assets/oceansgrn.png';
import land from '../../assets/landgrn.png';
import air from '../../assets/airgrn.png';
import near_space from '../../assets/near_spacegrn.png';
import take_action from '../../assets/take_actiongrn.png';
import './Menuscroll.css';
import {Link} from 'react-router-dom';

const Logo = styled.img`
  display: flex;
  position: absolute;
  transform: translate(-15px);
  height: 100%;
  top 0;
  left0;
  
  z-index:500;

`;
const Menu = styled.div`
  display: flex;
  margin-left:110px;
  transform: translate(15px);
  width: auto;
  height:auto;
  flex-wrap: nowrap;
  flex-direction: row;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  ::-webkit-scrollbar {
    display: none;
 }
  
`;



const Impactwrapper = styled.div`
  margin-left:7px;
  margin-right:7px;
`;
const Btncontainer= styled.div` 
    border-style: solid;
    border-width:1px;
    border-radius:20px;
    border-color:#13F9B2;
    white-space: nowrap;
    color: #13F9B2;
    vertical-align: middle;
    text-align: middle;
    background: rgba(0, 0, 0, 0);
    font-family: roboto;
    font-weight: 400;
    padding-left:7px;
    padding-right:9px;
    padding-top:5px;
    padding-bottom:5px;
    flex-direction: row; 
    font-size: .9em;
    display: flex;
    align-items: center;
    justify-content: left;
    transition: all 0.2s;
    &:hover {
    background: rgba(19, 249, 178,0.1);
 }

`;
const Menuicon = styled.img`
  margin-left:0px;
  margin-right:5px;
  justify-content:center;
  align-self:center;
  width:20px;
  height:20px;

`;
const Navlink = styled(Link)`

    text-decoration:none;
    color:#13F9B2;
  
`;

const Menuscroll = props => (
	<header className = "toolbar">
	  <nav className = "toolbar__navigation">
	    
        <Link to="/"><Logo src= {logo}/></Link>
        <Menu>
        <Impactwrapper><Navlink to="/Oceans"><Btncontainer><Menuicon src= {oceans}/> OCEANS </Btncontainer></Navlink></Impactwrapper>
        <Impactwrapper><Navlink to="/Land"><Btncontainer><Menuicon src= {land}/> LAND </Btncontainer></Navlink></Impactwrapper>
        <Impactwrapper><Navlink to="/Atmosphere"><Btncontainer><Menuicon src= {air}/> ATMOSPHERE </Btncontainer></Navlink></Impactwrapper>
        <Impactwrapper><Navlink to="/Near-Space"><Btncontainer><Menuicon src= {near_space}/> NEAR SPACE </Btncontainer></Navlink></Impactwrapper>
        <Impactwrapper><Navlink to="/Take-Action"><Btncontainer><Menuicon src= {take_action}/> TAKE ACTION </Btncontainer></Navlink></Impactwrapper>

        </Menu>
	  </nav>
	</header>
	);

export default Menuscroll;